const ICON_NAMES = {
  lock: 'lock',
  parentalBlock: 'parental-block',
  play: 'play',
};

export function getIconFromBlockStatus(showLockIcon, isContentBlockedByParentalControl) {
  let iconName;
  if (showLockIcon) {
    iconName = ICON_NAMES.lock;
  } else if (isContentBlockedByParentalControl) {
    iconName = ICON_NAMES.parentalBlock;
  } else {
    iconName = ICON_NAMES.play;
  }

  return iconName;
}
